import React from "react";

const Newsletter = () => (
  <svg
    width="72px"
    height="72px"
    viewBox="0 0 72 72"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className="text-primary block"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(11.000000, 9.000000)">
        <polygon fill="#FFFFFF" points="0 22 0.5 55.5 49.5 55.5 50 22 25 0" />
        <path
          d="M0,22 L0,54 C0,55.5 0.458,56 2,56 L48,56 C49.5,56 50,55.5 50,54 L50,22"
          stroke="#5B5B5B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polygon
          fillOpacity="0.3"
          fill="currentColor"
          points="6 23 6 28 17 39 24.5 32 26.5 32 33 39 44 28 43.5 22.5 6.5 22"
        />
        <path
          d="M0,22 L22.82,0.879 C23.992,-0.293 25.891,-0.293 27.062,0.879 L50,22"
          stroke="#5B5B5B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M44,27.9988 L44,23.9998 C44,22.5828 43.458,21.9998 42,21.9998 L8,21.9998 C6.542,21.9998 6,22.5828 6,23.9998 L6,27.9988"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.9619,54.9463 L22.9999,33.0883 C24.1719,31.9153 25.8909,31.9153 27.0629,33.0883 L48.9759,55.0003"
          stroke="#5B5B5B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0,22 L17,39"
          stroke="#5B5B5B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33,39 L50,22"
          stroke="#5B5B5B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

export default Newsletter;
